import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";
import { PageHero } from "@/components/PageHero";
import { FadeUp, Stagger, item } from "@/components/Reveal";

const ANCHORS = ["Vision", "Mission", "Positionnement", "Positioning", "Une organisation intégrée", "An integrated organization", "An integrated organisation", "Nos engagements", "Our commitments"];

const groupSections = (sections) => {
  const groups = [];
  let cur = null;
  sections.forEach((s) => {
    if (ANCHORS.includes(s.title) || !cur) { cur = { ...s, children: [] }; groups.push(cur); }
    else cur.children.push(s);
  });
  return groups;
};

function Chapter({ group, image, grey, first }) {
  return (
    <section className={`${grey ? "bg-[var(--bg-grey)]" : "bg-white"} ${first ? "" : "border-t border-[var(--line)]"}`} data-testid={`about-chapter-${group.title}`}>
      <div className={`container-x ${first ? "pt-8 pb-20 md:pt-10 md:pb-28" : "py-20 md:py-28"}`}>
        <div className="grid grid-cols-12 gap-8">
          <FadeUp className="col-span-12 lg:col-span-5">
            <h2 className="h-section text-3xl sm:text-4xl lg:text-5xl text-black">{group.title}</h2>
            {group.text && <p className="mt-8 text-base md:text-lg leading-relaxed text-[var(--ink-2)] max-w-xl">{group.text}</p>}
            {image && <div className="img-frame mt-10 aspect-[4/3] max-w-xl"><img src={image} alt="" loading="lazy" /></div>}
          </FadeUp>
          <Stagger className="col-span-12 lg:col-span-6 lg:col-start-7 divide-y divide-[var(--line)]" stagger={0.1}>
            {group.children.map((c) => (
              <motion.div key={c.title} variants={item} className="py-7">
                <h3 className="font-head text-xl md:text-2xl font-medium tracking-tight text-black">{c.title}</h3>
                <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-[var(--ink-2)]">{c.text}</p>
              </motion.div>
            ))}
          </Stagger>
        </div>
      </div>
    </section>
  );
}

export default function About() {
  const { content } = useLang();
  const { about, ui } = content;
  const groups = groupSections(about.sections);
  const images = [null, null, IMAGES.about.organization, IMAGES.about.industrial, null];
  return (
    <>
      <PageHero label={about.heading} intro={about.intro} image={IMAGES.about.hero} titleOnImage />
      {groups.map((g, i) => <Chapter key={g.title} group={g} image={images[i]} grey={i % 2 === 1} first={i === 0} />)}
      <section className="border-t border-[var(--line)] bg-white">
        <div className="container-x py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <p className="font-head text-2xl md:text-3xl text-black">{content.activities.heading}</p>
          <Link to="/activites" data-testid="about-activities-cta" className="btn-dark">{about.cta || ui.discoverActivities} <ArrowRight size={16} /></Link>
        </div>
      </section>
    </>
  );
}
